import footerTpl from './base';

const footerModATpl = (initData = {}) => {
   return footerTpl({ moddCls: 'ck-footer-mod-a' });
}

export { footerTpl, footerModATpl }